import type { ChatMessage, ChatResponse } from '@/api/types';
import { parseChatResponse, trimChatHistory } from './chatCore';

export type ChatApi = {
  createChatResponse(messages: ChatMessage[]): Promise<ChatResponse>;
};

export const requestChatResponse = async (
  api: ChatApi,
  messages: readonly ChatMessage[],
): Promise<ChatResponse> => {
  const value = await api.createChatResponse(trimChatHistory(messages));
  return parseChatResponse(value);
};
